import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { QuestionnaireStatus } from '@gig/magic-sdk/dist/adapter/users/getUserQuestionnaires';
import { Questionnaire } from './questionnaire/index.js';

var QuestionnairesComponent = /** @class */ (function (_super) {
    __extends(QuestionnairesComponent, _super);
    function QuestionnairesComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.questionnairesList = [];
        _this.loading = true;
        return _this;
    }
    QuestionnairesComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        user = magic.session.getUser();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = this;
                        return [4 /*yield*/, magic.methods.users.getUserQuestionnaires({
                                userProfileId: user.id,
                            })];
                    case 2:
                        _a.questionnairesList =
                            _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        console.error('Failed to fetch questionnaires:', error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    QuestionnairesComponent.prototype.getStatusClasses = function (status) {
        switch (status) {
            case QuestionnaireStatus.REQUESTED:
                return 'status--alert';
            case QuestionnaireStatus.SUBMITTED || QuestionnaireStatus.VERIFIED:
                return 'status--success';
            case QuestionnaireStatus.REJECTED || QuestionnaireStatus.EXPIRED:
                return 'status--error';
        }
    };
    QuestionnairesComponent.prototype.getStatusIcons = function (status) {
        switch (status) {
            case QuestionnaireStatus.REQUESTED:
                return 'alert';
            case QuestionnaireStatus.SUBMITTED || QuestionnaireStatus.VERIFIED:
                return 'quick-deposit-success';
            case QuestionnaireStatus.REJECTED || QuestionnaireStatus.EXPIRED:
                return 'close-circle';
        }
    };
    QuestionnairesComponent.prototype.getStatusTranslations = function (status) {
        switch (status) {
            case QuestionnaireStatus.REQUESTED:
                return this.$t('questionnaire-status.requested');
            case QuestionnaireStatus.SUBMITTED:
                return this.$t('questionnaire-status.submitted');
            case QuestionnaireStatus.VERIFIED:
                return this.$t('questionnaire-status.verified');
            case QuestionnaireStatus.REJECTED:
                return this.$t('questionnaire-status.rejected');
            case QuestionnaireStatus.EXPIRED:
                return this.$t('questionnaire-status.expired');
            default:
                return '';
        }
    };
    QuestionnairesComponent.prototype.isButtonEnabled = function (status) {
        return status !== QuestionnaireStatus.REQUESTED;
    };
    QuestionnairesComponent.prototype.openQuestionnaire = function (questionnaire) {
        if (this.isButtonEnabled(questionnaire.status)) {
            return;
        }
        else {
            this.emitQuestionnaire(questionnaire.questionnaireTemplateId, questionnaire.id);
        }
    };
    QuestionnairesComponent.prototype.emitQuestionnaire = function (questionnaireId, id) {
        return { questionnaireId: questionnaireId, id: id };
    };
    __decorate([
        Emit('get-id'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], QuestionnairesComponent.prototype, "emitQuestionnaire", null);
    QuestionnairesComponent = __decorate([
        Component({
            name: 'corex-questionnaires',
            components: {
                questionnaire: Questionnaire,
            },
        })
    ], QuestionnairesComponent);
    return QuestionnairesComponent;
}(Mixins(MagicConfigMixin)));

export default QuestionnairesComponent;
